/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Demo_Action_Send_TextInputs */

const en_mcp_demo_action_send_text = /** @type {(inputs: Mcp_Demo_Action_Send_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send text to Listening`)
};

const es_mcp_demo_action_send_text = /** @type {(inputs: Mcp_Demo_Action_Send_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar texto a Listening`)
};

/**
* | output |
* | --- |
* | "Send text to Listening" |
*
* @param {Mcp_Demo_Action_Send_TextInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_demo_action_send_text = /** @type {((inputs?: Mcp_Demo_Action_Send_TextInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Demo_Action_Send_TextInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_demo_action_send_text(inputs)
	return en_mcp_demo_action_send_text(inputs)
});